"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidTargets = exports.TargetSelect = exports.TargetTypes = void 0;
var TargetTypes;
(function (TargetTypes) {
    TargetTypes["Self"] = "Self";
    TargetTypes["FriendlyCreature"] = "FriendlyCreature";
    TargetTypes["EnemyCreature"] = "EnemyCreature";
    TargetTypes["EnemyMonkey"] = "EnemyMonkey";
})(TargetTypes = exports.TargetTypes || (exports.TargetTypes = {}));
var TargetSelect;
(function (TargetSelect) {
    TargetSelect[TargetSelect["ByPlayer"] = 0] = "ByPlayer";
    TargetSelect[TargetSelect["Auto"] = 1] = "Auto";
    TargetSelect[TargetSelect["Event"] = 2] = "Event";
})(TargetSelect = exports.TargetSelect || (exports.TargetSelect = {}));
const getValidTargets = (card, cardTargets, player, opponent) => {
    const selectableTargets = [];
    if (cardTargets.type.includes(TargetTypes.Self))
        selectableTargets.push(card);
    if (cardTargets.type.includes(TargetTypes.FriendlyCreature))
        selectableTargets.push(...player.board.filter((c) => c.uid !== card.uid));
    if (cardTargets.type.includes(TargetTypes.EnemyCreature))
        selectableTargets.push(...opponent.board);
    if (cardTargets.type.includes(TargetTypes.EnemyMonkey))
        selectableTargets.push(TargetTypes.EnemyMonkey);
    return selectableTargets;
};
exports.getValidTargets = getValidTargets;
